export default __webpack_public_path__ + "56dd77e534d9efd8dd6365356ce07488.png";